// extracted by mini-css-extract-plugin
export default {"container":"del_1SyuA","title":"del_tit_1i7C2","actions":"del_act_3ib5l","control":"del_con_1a6IQ","button":"del_but_3NRPW"};